import React from 'react';
import AdminMenuGrid from '../components/AdminMenuGrid';
import {
  RefreshCw, Plus, Search, BookOpen, FileX, ListChecks,
  Link2, CalendarClock, ArrowDownUp, Settings2
} from 'lucide-react';

const AccountingHubPage = () => {
  const items = [
    { label: 'Frequent Postings', icon: RefreshCw, path: '/dashboard/accounting/frequent-postings', id: 'frequent-postings' },
    { label: 'Chart of Accounts', icon: BookOpen, path: '/dashboard/accounting/chart-of-accounts', id: 'chart-of-accounts' },
    { label: 'Create Journal Entries', icon: Plus, path: '/dashboard/accounting/create-journal', id: 'create-journal' },
    { label: 'Closing Entries', icon: FileX, path: '/dashboard/accounting/closing-entries', id: 'closing-entries' },
    { label: 'Search Journal Entries', icon: Search, path: '/dashboard/accounting/search-journal', id: 'search-journal' },
    { label: 'Accounting Rules', icon: ListChecks, path: '/dashboard/accounting/rules', id: 'accounting-rules' },
    { label: 'Accounts Linked to Financial Activities', icon: Link2, path: '/dashboard/accounting/financial-activities', id: 'financial-activities' },
    { label: 'Accruals', icon: CalendarClock, path: '/dashboard/accounting/accruals', id: 'accruals' },
    { label: 'Migrate Opening Balances (Office-wise)', icon: ArrowDownUp, path: '/dashboard/accounting/migrate-balances', id: 'migrate-balances' },
    { label: 'Provisioning Entries', icon: Settings2, path: '/dashboard/accounting/provisioning', id: 'provisioning' },
  ];

  return <AdminMenuGrid title="Accounting" breadcrumb={['Accounting', 'Home / Accounting']} items={items} />;
};

export default AccountingHubPage;
